import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { grammarCheckpointItemSchema } from '../schemas';

const getGrammarCheckpointV1DataSchemaDefinition = z.object({
  token: z.string(),
  items: z.array(grammarCheckpointItemSchema),
  size: z.number().int().min(0),
});

export const getGrammarCheckpointV1DataSchema: typeof getGrammarCheckpointV1DataSchemaDefinition =
  getGrammarCheckpointV1DataSchemaDefinition;

export type IGetGrammarCheckpointV1Data = z.infer<typeof getGrammarCheckpointV1DataSchema>;

export const getGrammarCheckpointV1ResponseSchema: z.ZodSchema<IAPI<IGetGrammarCheckpointV1Data>> =
  createApiResponseSchema(getGrammarCheckpointV1DataSchema) as z.ZodSchema<
    IAPI<IGetGrammarCheckpointV1Data>
  >;

export type IGetGrammarCheckpointV1Response = IAPI<IGetGrammarCheckpointV1Data>;
